(function () {
  'use strict';

  const FEATURE_FLAG_EU_LANGUAGES = 'SVP403_EU_LANGUAGE_ENABLED',
      idiomas = [
        {key: 'PT_BR', value: 'Português'},
        {key: 'ES_ES', value: 'Español'},
        {key: 'EN_US', value: 'English'},
        {key: 'EN_GB', value: 'English (UK)', euLanguage: true},
        {key: 'DE_DE', value: 'Deutsch', euLanguage: true},
        {key: 'FR_FR', value: 'Français', euLanguage: true},
        {key: 'IT_IT', value: 'Italiano', euLanguage: true},
        {key: 'NL_NL', value: 'Nederlands', euLanguage: true},
        {key: 'PL_PL', value: 'Polski', euLanguage: true}
      ],
      idiomasBase = idiomas.filter(idioma => !idioma.euLanguage),
      funcoes = {
        getIdiomaByKey: (key) => idiomas.find(idioma => idioma.key === key),
        getAllIdiomas: () => featurehubJsSdk.isFeatureEnabled(FEATURE_FLAG_EU_LANGUAGES) ? idiomas : idiomasBase
      };

  angular
    .module('enumModule')
    .constant('IdiomasEnum', Object.assign({}, idiomas, funcoes));
}());
